import vars from '../helpers';

const init = () => {
	const $document = $(document);
	const $test = $('.test');
	const $start = $test.find('.test__start');
	const $step = $test.find('.test__step');
	const $result = $test.find('.test__result');
	const $banner = $test.find('.test__banner');
	const $answer = $test.find('.test__answer');
	const $resultTitle = $result.find('.test__name');
	const $resultDescription = $result.find('.test__surname');
	const $resultText = $result.find('.test__description');

	const $startButton = $test.find('.js-test-start');
	const $answerButton = $test.find('.js-test-answer');
	const $nextButton = $test.find('.js-test-next');
	const $reloadButton = $test.find('.js-test-reload');

	const $yourResult = $test.find('.test__your-result span');
	const $headerTest = $('.header__title');

	const $share = vars.$document.find('.js-footer .js-share');

	const answers = [1, 2, 0, 2, 1, 0, 3, 2];

	let correctAnswersCount = 0;

	function getResultIndex() {
		let index = null;

		if (correctAnswersCount > 0 && correctAnswersCount <= 3 || correctAnswersCount === 3) {
			index = 0;
			// eslint-disable-next-line max-len
		} else if (correctAnswersCount > 4 && correctAnswersCount <= 6 || correctAnswersCount === 4 || correctAnswersCount === 6) {
			index = 1;
		} else if (correctAnswersCount > 7 || correctAnswersCount === 7) {
			index = 2;
		}

		return index;
	}

	function setUrlParam(resetParams) {
		let url = '';
		let resultParamExists = location.search.indexOf('result=') !== -1;

		if (resetParams && resultParamExists) {
			url = location.origin + location.pathname;

			history.replaceState(null, null, url);
		} else if (!resetParams) {
			url = `${location.origin}${location.pathname}?result=${getResultIndex()}`;

			history.replaceState(null, null, url);
		}
	}

	function reset() {
		correctAnswersCount = 0;

		$start.removeClass('is-hidden');
		$step.addClass('is-hidden').removeClass('is-done');
		$result.addClass('is-hidden');
		$banner.addClass('is-hidden');
		$answer.removeClass('is-selected is-correct is-wrong');
		$resultTitle.addClass('is-hidden');
		$resultDescription.addClass('is-hidden');
		$resultText.addClass('is-hidden');
		$headerTest.addClass('is-hidden');
		$nextButton.removeClass('is-disabled');
		$share.removeClass('is-hidden');

		gsap.killTweensOf([$start, $step, $result]);
		gsap.set([$start, $step, $result], {clearProps: 'all'});

		setUrlParam(true);
	}

	function reload() {
		gsap.timeline({
			onComplete: reset,
		})
			.to($result, 0.3, {
				opacity: 0,
			})
			.call(() => {
				$result.addClass('is-hidden');
				$start.removeClass('is-hidden');
				$banner.addClass('is-hidden');
				$headerTest.addClass('is-hidden');
				$share.removeClass('is-hidden');

				gsap.killTweensOf($result);
				gsap.set($result, {clearProps: 'all'});
			})
			.from([$start, $banner], 0.3, {
				opacity: 0,
			});

		$document.trigger('test-reload');
	}

	function result() {
		const resultIndex = getResultIndex();

		$test.find('.test__result').attr('data-result', resultIndex);

		const $lastStep = $step.last();
		const $activeResultTitle = $resultTitle.eq(resultIndex);
		const $activeResultDescription = $resultDescription.eq(resultIndex);
		const $activeResultText = $resultText.eq(resultIndex);

		$activeResultTitle.removeClass('is-hidden');
		$activeResultDescription.removeClass('is-hidden');
		$activeResultText.removeClass('is-hidden');
		$yourResult.text(correctAnswersCount);

		gsap.timeline()
			.to([$lastStep], 0.3, {
				opacity: 0,
				onComplete() {
					if (vars.isMobile()) {
						$share.addClass('is-hidden');
					}
				},
			})
			.call(() => {
				$lastStep.addClass('is-hidden');
				$result.removeClass('is-hidden');
				$banner.removeClass('is-hidden');

				gsap.killTweensOf([$lastStep, $banner]);
				gsap.set([$lastStep], {clearProps: 'all'});
			})
			.from([$result], 0.3, {
				opacity: 0,
			});

		setUrlParam();

		$document.trigger('test-result', [$activeResultTitle.text().split('', 100).join(''), correctAnswersCount]);

		if (!vars.isMobile()) {
			ga('send', 'event', 'banner', 'show', 'bottom banner - Asus', {nonInteraction: true});
		}
	}

	function next(event) {
		const $currentStep = $(event.currentTarget).closest('.test__step');
		const $nextStep = $currentStep.next('.test__step');

		$currentStep.find('.js-test-next').addClass('is-disabled');

		if (!$currentStep.hasClass('is-done')) {
			return;
		}

		$('html, body').animate({
			scrollTop: 0,
		}, 500);

		if (!$nextStep.length) {
			result();

			return;
		}

		const nextStepIndex = $nextStep.data('index');
		const nextQuestion = $nextStep.find('.test__question').text();

		gsap.timeline()
			.to($currentStep, 0.3, {
				opacity: 0,
			})
			.call(() => {
				$currentStep.addClass('is-hidden');
				$nextStep.removeClass('is-hidden');

				gsap.killTweensOf($currentStep);
				gsap.set($currentStep, {clearProps: 'all'});
			})
			.from($nextStep, 0.3, {
				opacity: 0,
			});

		$document.trigger('test-question-show', [nextStepIndex + 1, nextQuestion.split('', 100).join('')]);
	}

	function answer(event) {
		const $currentAnswer = $(event.currentTarget);
		const $currentStep = $currentAnswer.closest('.test__step');

		const stepIndex = $currentStep.data('index');
		const answerIndex = $currentAnswer.data('index');
		const answerText = $currentAnswer.find('.test__radio').text();

		if (answers[stepIndex] === answerIndex) {
			$currentAnswer.addClass('is-correct');

			correctAnswersCount++;
		} else {
			$currentAnswer
				.addClass('is-wrong')
				.siblings(`[data-index="${answers[stepIndex]}"]`)
				.addClass('is-correct');
		}

		$currentStep.addClass('is-done');
		$currentAnswer.addClass('is-selected');

		$document.trigger('test-answer', [stepIndex + 1, answerText.split('', 100).join('')]);
	}

	function start() {
		const $firstStep = $step.first();

		const stepIndex = $firstStep.data('index');
		const question = $firstStep.find('.test__question').text();

		gsap.timeline()
			.to([$start], 0.3, {
				opacity: 0,
				clearProps: 'all',
			})
			.call(() => {
				$start.addClass('is-hidden');
				$firstStep.removeClass('is-hidden');
				$banner.addClass('is-hidden');
				$headerTest.removeClass('is-hidden');

				gsap.killTweensOf([$start]);
				gsap.set([$start], {clearProps: 'all'});
			})
			.from($firstStep, 0.3, {
				opacity: 0,
				clearProps: 'all',
			});

		$document
			.trigger('test-start')
			.trigger('test-question-show', [stepIndex + 1, question.split('', 100).join('')]);
	}

	$startButton.on('click', start);
	$answerButton.on('click', answer);
	$nextButton.on('click', next);
	$reloadButton.on('click', reload);
};

export default {
	init,
};

